import { render, staticRenderFns } from "./SvgMinus.vue?vue&type=template&id=409dc198&scoped=true&"
import script from "./SvgMinus.vue?vue&type=script&lang=js&"
export * from "./SvgMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409dc198",
  null
  
)

export default component.exports